module.exports = __webpack_public_path__ + "static/media/kylemore.5cde48ab.png";